import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import ChargeTransactionDetailScreen from '../ChargeTransaction/screens/ChargeTransactionDetailScreen';
import ChargeVehicleDetailScreen from './screens/ChargeVehicleDetailScreen';
import ChargeVehicleListScreen from './screens/ChargeVehicleListScreen';

function ChargeVehicle(props) {
  return (
    <KT01BaseLayout isFullScreen={true}>
      <div className="container-fluid px-0">
        <Routes>
          <Route path="" element={<ChargeVehicleListScreen />} />
          <Route path=":chargeVehicleId" element={<ChargeVehicleDetailScreen />} />
          <Route
            path=":chargeVehicleId/transaction/:chargeTransactionId"
            element={<ChargeTransactionDetailScreen />}
          />
          <Route path="*" element={<>Đường dẫn không hợp lệ</>} />
        </Routes>
      </div>
    </KT01BaseLayout>
  );
}

export default ChargeVehicle;
